import breadcrumbsStore from "./FolderStore";
import navStore from "./projectStore";
import breadStore from "./breadcrumbStore";

export default { navStore, breadcrumbsStore ,breadStore};
